/*
  Figma "Progress bar": 6px, fill/secondary track, accent/default fill. Always
  shown next to the number it stands for, so it is hidden from screen readers.
*/
const ProgressBar = ({ value = 0, className = "" }) => {
  const percent = Math.max(0, Math.min(100, Number(value) * 100 || 0));
  return (
    <div className={`relative h-[6px] w-full overflow-hidden rounded-full bg-fill-secondary ${className}`} aria-hidden="true">
      <div className="absolute inset-y-0 left-0 rounded-full bg-accent-default" style={{ width: `${percent}%` }} />
    </div>
  );
};

export default ProgressBar;
